import {default as classNames} from "classnames";
import {AnimatePresence, motion} from "motion/react";
import {useContext} from "react";

import {NavBarContext} from "@/components/navBar/NavBar.utils.tsx";
import {NavBarHeader} from "@/components/navBar/subComponents/NavBarHeader/NavBarHeader.tsx";
import {NavBarNavItems} from "@/components/navBar/subComponents/NavBarNavItems/NavBarNavItems.tsx";
import {NavBarProfile} from "@/components/navBar/subComponents/NavBarProfile/NavBarProfile.tsx";
import {NavBarProfileButtonMobile} from "@/components/navBar/subComponents/NavBarProfileButtonMobile/NavBarProfileButtonMobile.tsx";
import {NavBarProfileMobileMenu} from "@/components/navBar/subComponents/NavBarProfileMobileMenu/NavBarProfileMobileMenu.tsx";
import {NavBarSubAccountSelect} from "@/components/navBar/subComponents/NavBarSubAccountSelect/NavBarSubAccountSelect.tsx";

import styles from "./NavBar.module.scss";

export const NavBar = () => {
  const {isMobile, isMenuOpen, isProfileMenuOpen, setIsProfileMenuOpen} = useContext(NavBarContext);

  return (
    <div className={classNames("pulseNavBar", styles.navBar)}>
      {!isMobile && (
        <>
          <NavBarHeader />
          <div className={"overflow-y-auto"}>
            <NavBarSubAccountSelect />
            <NavBarNavItems />
          </div>
          <NavBarProfile />
        </>
      )}
      {isMobile && (
        <>
          <NavBarHeader />
          <AnimatePresence>
            {isMenuOpen && (
              <motion.div
                initial={{opacity: 0, height: 0}}
                animate={{opacity: 1, height: "calc(100% - 56px)"}} // 56px is the height of the header
                exit={{opacity: 0, height: 0}}
                transition={{duration: 0.3}}
                className={styles.navBarMobile}
              >
                {!isProfileMenuOpen && (
                  <>
                    <div className={"overflow-y-auto"}>
                      <NavBarSubAccountSelect />
                      <NavBarNavItems />
                    </div>
                    <NavBarProfileButtonMobile
                      showMobileProfile={isProfileMenuOpen}
                      setShowMobileProfile={setIsProfileMenuOpen}
                    />
                  </>
                )}
              </motion.div>
            )}
          </AnimatePresence>

          <AnimatePresence>
            {isProfileMenuOpen && (
              <motion.div
                initial={{opacity: 0, height: 0}}
                animate={{opacity: 1, height: "100%"}}
                exit={{opacity: 0, height: 0}}
                transition={{duration: 0.3}}
                className={styles.navBarProfileMobile}
              >
                <NavBarProfileMobileMenu />
              </motion.div>
            )}
          </AnimatePresence>
        </>
      )}
    </div>
  );
};
